import { createApp } from 'vue'
import Sos from '@/components/sos/Sos.vue'
import { loadTranslations } from '@/js/global/vue-i18n'

const app = createApp(Sos)

loadTranslations(app).then(() => {
    app.mount("#sos-vue")
})